import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { API_SERVER, initializeFilterData } from '../../EnvConfig/env_config';
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FindTranslatedKey, deleteData } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const GroupMasterForm = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch([])
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [formData, setFormData] = useState({
        userGroupID: '',
        groupName: '',
        active: true
    });

    const getGroupMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/User/ShowUserGroupMaster`, data)
        if (res.Status === 'SUCCESS') {
            setTableData(res)
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = () => {
        setFormData({
            groupName: '',
            userGroupID: '',
            active: true,
        })
        filterData.SearchText = ''
        getGroupMasterData()
        inputrefs.current['txtGroupName'].focus()
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/User/InsertUpdateUserGroupMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/User/EditUserGroupMaster`, { UserGroupID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR'|| editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/User/DeleteUserGroupMaster`, { UserGroupID: id }, getGroupMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleChange1 = (event, value) => {
        getGroupMasterData(value);
    };

    useEffect(() => {
        inputrefs.current['txtGroupName'].focus()
        document.title = 'Group Master'
        getGroupMasterData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {FindTranslatedKey('Group Master')} </h6>
                    </div>
                    <div className='card-body pb-1'>
                        <div className='row'>
                            <InputBox
                                label='Group Name'
                                required={true}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActive'].focus()
                                    }
                                }}
                                inputrefs={inputrefs}
                                id="txtGroupName"
                                PlaceHolderText='Group Name'
                                type="text"
                                maxLength='30'
                                value={formData.groupName}
                                onChange={(e) => setFormData({ ...formData, groupName: e.target.value })}
                            />
                            <Switch
                                label='Active'
                                checked={formData.active}
                                id='txtActive'
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['btnSub'].focus()
                                    };
                                }}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                            />
                        </div>
                    </div>
                    <div className='card-body'>
                        <FormButton
                            id={'btnSub'}
                            inputrefs={inputrefs}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                handleDownloadExcel(`/api/User/ShowUserGroupMaster`, filterData, 'Group Master')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear}
                        />
                    </div>
                </div>
            </div>
            <Table
                handleEdit={handleEditData}
                handleDelete={handleDelete}
                loading={isLoading}
                PageName={'GroupMaster'}
                handleFilter={() => {
                    getGroupMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
            />
        </>
    )
}
export default GroupMasterForm;